import { createTheme, Theme } from "@mui/material/styles";

const darkTheme: Theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#3B82F6", light: "#60A5FA", dark: "#2563EB" },
    secondary: { main: "#22C55E", light: "#4ADE80", dark: "#16A34A" },
    background: {
      default: "#0B1120",
      paper: "#111827",
    },
  },

  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontSize: "2.5rem", fontWeight: 700 },
    h2: { fontSize: "2rem", fontWeight: 700 },
    h3: { fontSize: "1.75rem", fontWeight: 700 },
    h4: { fontSize: "1.5rem", fontWeight: 700 },
    h5: { fontSize: "1.25rem", fontWeight: 700 },
    h6: { fontSize: "1rem", fontWeight: 700 },
    allVariants: { color: "#E5EDF8" },
  },

  shape: { borderRadius: 12 },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 700,
          borderRadius: 8,
          minHeight: 38,
          paddingInline: 16,
          textTransform: "none",
          boxShadow: "0 10px 24px rgba(59,130,246,0.16)",
          transition: "all .22s ease",
          "&:hover": {
            boxShadow: "0 14px 30px rgba(59,130,246,0.24)",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid #263244",
          boxShadow: "0 8px 24px rgba(0,0,0,.18)",
          backgroundImage: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          background: "rgba(17,24,39,0.65)",
          backdropFilter: "blur(20px)",
          border: "1px solid #1F2937",
          transition: "all .25s ease",
          "&:hover": {
            boxShadow: "0 18px 40px rgba(0,0,0,0.28)",
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: { size: "small" },
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": { borderRadius: 8, minHeight: 42 },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
          border: "1px solid #263244",
          boxShadow: "0 24px 64px rgba(0,0,0,.42)",
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: { root: { fontWeight: 800, padding: "20px 24px 12px" } },
    },
    MuiDialogActions: {
      styleOverrides: { root: { padding: "16px 24px 20px" } },
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 6, fontWeight: 800, fontSize: "0.72rem", height: 26 },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { height: 3, borderRadius: "3px 3px 0 0" },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          width: 240,
          background: "linear-gradient(180deg,#0B1120 0%,#111827 100%)",
          borderRight: "1px solid #1F2937",
          boxShadow: "10px 0 34px rgba(0,0,0,0.34)",
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          margin: "4px 8px",
          transition: "all .22s ease",
          "&:hover": {
            background: "rgba(59,130,246,0.12)",
          },
          "&.Mui-selected": {
            background: "rgba(59,130,246,0.18)",
            color: "#EFF6FF",
          },
        },
      },
    },
  },
});

export default darkTheme;
